module.exports = __webpack_public_path__ + "static/media/YF04_0.c917ec96.jpg";